import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
export var createEventTargetConstructor = function createEventTargetConstructor(wrapEventListener) {
  return /*#__PURE__*/function () {
    function EventTarget(_nativeEventTarget) {
      _classCallCheck(this, EventTarget);

      this._nativeEventTarget = _nativeEventTarget;
      this._listeners = new WeakMap();
    }

    _createClass(EventTarget, [{
      key: "addEventListener",
      value: function addEventListener(type, listener, options) {
        if (listener !== null) {
          var wrappedEventListener = this._listeners.get(listener);

          if (wrappedEventListener === undefined) {
            wrappedEventListener = wrapEventListener(this, listener);

            if (typeof listener === 'function') {
              this._listeners.set(listener, wrappedEventListener);
            }
          }

          this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        return this._nativeEventTarget.dispatchEvent(event);
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, listener, options) {
        var wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);

        this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
      }
    }]);

    return EventTarget;
  }();
};